import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const SatisfactionIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
        >
            <path
                d="M7 10V18C7 18.2652 6.89464 18.5196 6.70711 18.7071C6.51957 18.8946 6.26522 19 6 19H4C3.73478 19 3.48043 18.8946 3.29289 18.7071C3.10536 18.5196 3 18.2652 3 18V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H7ZM7 10C8.06087 10 9.07828 9.57857 9.82843 8.82843C10.5786 8.07828 11 7.06087 11 6V5C11 4.46957 11.2107 3.96086 11.5858 3.58579C11.9609 3.21071 12.4696 3 13 3C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5V10H18C18.5304 10 19.0391 10.2107 19.4142 10.5858C19.7893 10.9609 20 11.4696 20 12L19 17C18.8562 17.6135 18.5834 18.1402 18.2227 18.501C17.8619 18.8617 17.4328 19.0368 17 19H10C9.20435 19 8.44129 18.6839 7.87868 18.1213C7.31607 17.5587 7 16.7956 7 16"
                strokeLinecap="round"
                strokeLinejoin="round"
            />{' '}
        </svg>
    </IconWrapper>
)
